'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardIntegrationsCtrl',  require('./dashboardIntegrationsCtrl'));
//app.directive('integrations', [require('./dashboardIntegrationsDirective')]);
app.config(['$stateProvider', require('./dashboardIntegrationsConfig')]);
